// extracted by mini-css-extract-plugin
module.exports = {"currencyType":"_93444fe79c--currencyType--dD0Vo"};